// extracted by mini-css-extract-plugin
module.exports = {"root":"loginFormPanel_root__23kE5","loginForm":"loginFormPanel_loginForm__3FY3c"};